import React, { useState, useEffect} from "react";
import { Box, Typography} from "@mui/material";
import scroll1 from "../../../assets/TropicalSuiteImg/TS16.jpg";
import HoverButton from "../../HoverButton";
import EastIconArrow from "../../../assets/east.svg";
import { useNavigate } from "react-router-dom";

const MobileScroll1 = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 500);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const imageStyle = {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    };

    const imageContainerStyle = {
        width: "95%",
        maxWidth: "768px",
        height: "90%",
        borderRadius: "300px 300px 0px 0px",
        overflow: "hidden",
    };

    const textContainerStyle = {
        width: "95%",
        maxWidth: "768px",
        textAlign: "left",
        alignSelf: "center",
        paddingLeft: "0px",
    };

    const headingStyle = {
        maxWidth: "100%",
        width: "100%",
        fontFamily: "'ZapfHumnst BT'",
        fontWeight: 400,
        whiteSpace: "normal",
        fontSize: isMobile ? "32px" : "74px",
        lineHeight: isMobile ? "39.61px" : "91.6px",
        letterSpacing: "0.03em",
        color: "#2A2A2A",
        paddingY: "15px",
    };

    const descriptionStyle = {
        fontFamily: "'Sora', sans-serif",
        fontSize: isMobile ? "12px" : "16px",
        fontWeight: 300,
        color: "#000000",
        paddingBottom: "15px",
    };

    return (
        <Box
            boxSizing="border-box"
            width="100%"
            bgcolor="#DCF6EF"
            height="100%"
            position="relative"
            display="flex"
            padding="20px"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
        >
            {/* Image Container */}
            <Box sx={imageContainerStyle}>
                <img src={scroll1} alt="scroll animation" style={imageStyle} />
            </Box>

            {/* Text Content */}
            <Box sx={textContainerStyle}>
                <Typography sx={headingStyle}>
                    {isMobile ? (
                        <>
                            <span style={{ display: "block" }}>THE</span>
                            <span style={{ display: "block" }}>TROPICAL</span>
                            <span style={{ display: "block" }}>SUITE</span>
                        </>
                    ) : (
                        "THE TROPICAL SUITE"
                    )}
                </Typography>

                <Typography sx={descriptionStyle}>
                    A vibrant retreat with lush greenery and breezy interiors, perfect for a refreshing stay.  Relax in a nature-inspired space, where comfort meets tranquility for a truly rejuvenating escape.
                    <br />
                    <br />
                    2000 sq. ft. • max. 4 guests
                </Typography>

                <HoverButton
                    onClick={() => navigate("/the-tropical-suite")}
                    width="132px"
                    height="50px"
                    endIcon={
                        <img
                            src={EastIconArrow}
                            alt="east"
                            style={{
                                width: "25px",
                                height: "25px",
                                transform: "rotate(-50deg)",
                            }}
                        />
                    }
                    btnText="Step in"
                    fillBgColor="#9DC5B9"
                />
            </Box>
        </Box>
    );
};

export default MobileScroll1;
